import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListMichelinStockComponent } from './list-michelin-stock/list-michelin-stock.component';
import { UpdateMichelinStockComponent } from './update-michelin-stock/update-michelin-stock.component';
import { permissionGuard } from 'src/app/shared/guards/permission/permission.guard';
import { Permission } from 'src/app/shared/models/permission/permission-dto';

const routes: Routes = [
  {
    path: '',
    canActivate: [permissionGuard],
    data: { permission: Permission.LIST_MICHELIN_STOCK },
    component: ListMichelinStockComponent
  },
  {
    path: 'update',
    canActivate: [permissionGuard],
    data: { permission: Permission.UPDATE_MICHELIN_STOCK },
    component: UpdateMichelinStockComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MichelinStockRoutingModule {}
